import { cloneElement, Fragment, useState } from "react";
import Button from "react-bootstrap/Button";
import Modal from "react-bootstrap/Modal";
import ModalHeader from "react-bootstrap/ModalHeader";
import ModalTitle from "react-bootstrap/ModalTitle";
import ModalBody from "react-bootstrap/ModalBody";
import ModalFooter from "react-bootstrap/ModalFooter";
import { Formik } from "formik";
import { AssignLearnerSchema } from "../../atoms/schema";
import { app_api } from "../../atoms/api";
import Form from "react-bootstrap/Form";
import FormControl from "react-bootstrap/FormControl";
import FloatingLabel from "react-bootstrap/FloatingLabel";
import Alert from "react-bootstrap/Alert";

export const ExistingLearner = (props) => {
  const [assign, setAssign] = useState(false);
  const [assignLoading, setAssignLoading] = useState(false);
  const [assignSucces, setAssignSuccess] = useState(false);
  const [assignError, setAssignError] = useState(null);

  const handleAssignOpen = () => setAssign(true);
  const handleAssignClose = () => setAssign(false);
  const dismissedAssignError = () => setAssignError(null);
  const dismissAssignSuccess = () => setAssignSuccess(false);
  return (
    <Fragment>
      {props.children &&
        cloneElement(props.children, {
          onClick: handleAssignOpen,
        })}
      {/* <Button
        variant="secondary"
        className="ms-auto"
        title="Use learner code to add learner"
        onClick={handleAssignOpen}
      >
        Add existing learner
      </Button> */}
      <Modal show={assign} onHide={handleAssignClose}>
        <ModalHeader closeButton={true}>
          <ModalTitle>Add a learner</ModalTitle>
        </ModalHeader>
        <ModalBody>
          <Formik
            initialValues={{ code: "" }}
            onSubmit={(values) => {
              setAssignLoading(true);
              setAssignError(null);
              app_api
                .patch(`/learner/assign/${values.code.toUpperCase()}`)
                .then((res) => {
                  setAssignLoading(false);
                  setAssignSuccess(true);
                  setAssignError(null);
                })
                .catch((err) => {
                  setAssignLoading(false);
                  setAssignSuccess(false);
                  setAssignError(
                    err?.response?.data?.message || "Error assigning learner"
                  );
                });
            }}
            validationSchema={AssignLearnerSchema}
          >
            {({
              handleBlur,
              handleChange,
              handleSubmit,
              values,
              touched,
              errors,
            }) => (
              <Form noValidate={true} onSubmit={handleSubmit}>
                {assignError && (
                  <Alert
                    variant="danger"
                    dismissible={true}
                    onClose={dismissedAssignError}
                  >
                    {assignError}
                  </Alert>
                )}
                {assignSucces && (
                  <Alert
                    variant="success"
                    dismissible={true}
                    onClose={dismissAssignSuccess}
                  >
                    Learner added successfully. Reload the page to see the
                    learner.
                  </Alert>
                )}
                <FloatingLabel
                  label="Learner code"
                  controlId="assign-learner.code"
                >
                  <FormControl
                    name="code"
                    type="text"
                    maxLength="6"
                    placeholder="Learner code"
                    onChange={handleChange}
                    onBlur={handleBlur}
                    isValid={touched.code && !errors.code}
                    isInvalid={touched.code && !!errors.code}
                    value={values.code}
                  />
                  {touched.code && (
                    <FormControl.Feedback type="invalid">
                      {errors.code}
                    </FormControl.Feedback>
                  )}
                </FloatingLabel>
                <ModalFooter>
                  <Button
                    variant="secondary"
                    onClick={handleAssignClose}
                    type="button"
                  >
                    Close
                  </Button>
                  <Button variant="primary" type="submit">
                    {assignLoading ? "Assigning..." : "Submit"}
                  </Button>
                </ModalFooter>
              </Form>
            )}
          </Formik>
        </ModalBody>
      </Modal>
    </Fragment>
  );
};
